import { Button as MantineButton } from '@mantine/core';

export const Button = MantineButton.extend({
	defaultProps: {
		variant: 'primary',
	},
});
